import { Population, User } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { UserPopulationPreferenceEntityConfig } from "./config";
import { UserPopulationPreferenceFilters } from "./filters";
import { UserPopulationPreferenceMethods } from "./methods";

@HyperEntity("user-population-preference", UserPopulationPreferenceEntityConfig)
export class UserPopulationPreference extends extender(
  UserPopulationPreferenceFilters,
  UserPopulationPreferenceMethods,
) {
  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Fields.string({ dbName: "population_id" })
  populationId = "";

  @Relations.toOne<UserPopulationPreference, Population>(
    () => Population,
    "populationId",
  )
  population?: Population;

  @Relations.toOne<UserPopulationPreference, User>(() => User, "userId")
  user?: User;

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();
}


